import React from 'react';
import { colors } from '@grnhse/seedling/lib/azalea/constants';
import t from 'shared/utils/translation';
import {
  ItalicDescription,
  MediumGrey,
} from './consent_extension_email.styles';
import { ConsentDecisionButtons } from './consent_decision_buttons';
import styled from 'styled-components';

export function SimulatedEmail({ previewEmail }) {
  return (
    <CardHeaderContainer>
      <EmailContent>
        <BodyContent
          data_test_rendered_html_body
          dangerouslySetInnerHTML={{ __html: previewEmail }} // eslint-disbale react/no-danger
        />
        {previewEmail && <br />}
        <StyledItalicDescription>
          <MediumGrey>
            {t('gdpr.consent_extension_email.footer.description')}
          </MediumGrey>
        </StyledItalicDescription>
      </EmailContent>

      <ConsentDecisionButtons
        approveText={t('gdpr.consent_extension_email.footer.keep_data')}
        denyText={t('gdpr.consent_extension_email.footer.delete_data')}
      />
    </CardHeaderContainer>
  );
}

const CardHeaderContainer = styled.header`
  border-radius: 3px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  background-color: ${colors.white};
  border: 1px solid ${colors.lightGrey};
  margin-left: 10px;
  padding: 29px 32px;
  position: relative;
  box-sizing: border-box;
`;

const StyledItalicDescription = styled(ItalicDescription)`
  font-weight: 400;
  margin-top: 0px;
`;

export const EmailContent = styled.div`
  line-height: 22px;
`;

const BodyContent = styled.div`
  font-weight: 400;
  font-size: 14px;
  strong {
    font-weight: bold;
  }

  em {
    font-style: italic;
  }

  a {
    color: ${colors.mediumBlue};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  hr {
    height: 1px;
    border: none;
    color: ${colors.mediumGrey};
    background-color: ${colors.mediumGrey};
    margin: 10px 0;
  }

  p {
    font-size: 14px;
  }

  ul {
    list-style-type: square;
    margin: 1em 0;
    padding-left: 40px;
  }

  ol {
    list-style-type: decimal;
    margin: 1em 0;
    padding-left: 40px;
  }

  li {
    display: list-item;
  }

  h1 {
    font-size: 22px;
    font-weight: 600;
    margin: 14px 0;
  }

  h2 {
    font-size: 20px;
    font-weight: 600;
    text-align: left;
    margin: 10px 0;
  }

  h3 {
    font-size: 18px;
    font-weight: 600;
    margin: 10px 0;
  }

  h4 {
    font-size: 16px;
    font-weight: 600;
    margin: 10px 0;
  }

  h5 {
    font-size: 14px;
    font-weight: 600;
    margin: 10px 0;
  }

  h6 {
    font-size: 12px;
    font-weight: 600;
    margin: 10px 0;
  }
`;
